import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Timestamp } from 'firebase/firestore';

const StatisticSection = ({ serviceProvider }) => {
  const COLORS = ['#EC3535', '#FF9999'];

  // Data for Pie Chart
  const genderData = [
    { name: 'Male', value: serviceProvider.maleRatio },
    { name: 'Female', value: serviceProvider.femaleRatio },
  ];

  // Data for Bar Chart
  const ageData = [
    { age: '18-24', percentage: serviceProvider.agePercentageBracket1 },
    { age: '25-34', percentage: serviceProvider.agePercentageBracket2 },
    { age: '35-44', percentage: serviceProvider.agePercentageBracket3 },
    { age: '45-54', percentage: serviceProvider.agePercentageBracket4 },
    { age: '55-64', percentage: serviceProvider.agePercentageBracket5 },
    { age: '65+', percentage: serviceProvider.agePercentageBracket6 },
  ];

  const isEmpty = (value) => value === null || value === undefined || value === 0 || value === '';

  if (
    isEmpty(serviceProvider.monthlyTraffic) &&
    isEmpty(serviceProvider.visitDuration) &&
    isEmpty(serviceProvider.maleRatio) &&
    isEmpty(serviceProvider.femaleRatio) &&
    ageData.every((item) => isEmpty(item.percentage))
  ) {
    return null; // Do not render if all statistics are empty (0, null, undefined, or '')
  }
  

  console.log('stats date: ', serviceProvider.dataUpdateDT || serviceProvider.updatedDT || serviceProvider.createdDT);

  return (
    <div style={{ padding: '16px', backgroundColor: 'white', borderRadius: '8px', marginTop: '16px',
      border: '1px solid rgba(0, 0, 0, 0.35)',
      borderRadius: '8px', }}>
      <h3 style={{ fontSize: '16px', fontWeight: 'bold' }}>Statistics</h3>
      {serviceProvider.dataUpdateDT && (
        <p style={{ fontSize: '12px', color: 'black' }}>
          Data as of {serviceProvider.dataUpdateDT.toDate().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
        </p>
      )}

      <div style={{ display: 'flex', gap: '16px 4px', marginTop: '4px', flexWrap: 'wrap' }}>
        {/* Monthly Traffic and Visit Duration */}
        <div style={{ flex: '1 1 200px' }}>
          {serviceProvider.monthlyTraffic > 0 && (
            <>
              <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '4px' }}>Monthly traffic</h4>
              <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                {serviceProvider.monthlyTraffic.toLocaleString()} visits
              </p>
            </>
          )}
            {serviceProvider.visitDuration != null && serviceProvider.visitDuration != '' && (
              <>
                <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '4px' }}>Visit duration</h4>
                <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  {serviceProvider.visitDuration.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                </p>
              </>
            )}


        </div>

        {/* Gender Pie Chart */}
        {serviceProvider.maleRatio > 0 && serviceProvider.femaleRatio > 0 && (
          <div style={{ flex: '1 1 200px', textAlign: 'center' }}>
            <h4 style={{ fontSize: '14px', fontWeight: 'bold' }}>Gender</h4>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={genderData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={60}
                  dataKey="value"
                  label={({ name, value }) => `${name} (${value}%)`}
                >
                  {genderData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}

        {/* Age Bar Chart */}
        {ageData.some((item) => item.percentage > 0) && (
  <div style={{ flex: '1 1 400px' }}>
    <h4 style={{ fontSize: '14px', fontWeight: 'bold' }}>Age</h4>
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={ageData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="age" />
        <YAxis domain={[0, (dataMax) => dataMax + 5]} />
        <Tooltip formatter={(value, name) => [`${value}%`, null]} />
        <Bar
          dataKey="percentage"
          fill="#EC3535"
          label={{
            position: 'top',
            formatter: (value) => `${value}%`,
          }}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
)}

      </div>
    </div>
  );
};

export default StatisticSection;
